import InternalClipboard from './clipboard'

const Clipboard = InternalClipboard

export { ClipboardAction, IClipboardProps } from './clipboard'
export default Clipboard
